import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'fr',
    debug: true,
    
    backend: {
      loadPath: '/i18n/{{lng}}.json',
      crossDomain: false,
      withCredentials: false,
    },
    
    interpolation: {
      escapeValue: false
    },
    
    react: {
      useSuspense: false
    },
    
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'selectedLanguage',
      caches: ['localStorage']
    }
  });

export default i18n;